module.exports = __webpack_public_path__ + "02_medium_black.e8c21fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_medium_black.png
// module id = 8/WB
// module chunks = 0